import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'isRequired' })
export class isRequiredPipe implements PipeTransform {
  transform(value: string, isRequired: boolean) {
    const newStr = isRequired ? ' *' : '';
    return value + newStr;
  }
}